import React from "react"
import Svg from "../_svgs/svg"

export default function MaterialProviderItem({ material, label }) {
  return (
    <div className="material-provider-item">
      <a data-epi-property="Label" href={material} target="_blank" rel="noreferrer">
        {label}
        <div className="arrowdown">
          <Svg iconName={"arrow_ff_down"} fillColor={"#060e4d"} />
        </div>
      </a>
    </div>
  )
}
